import React from 'react';
import { Alert } from '@mui/material';
import Select, { components } from 'react-select';
import { addDays, addYears } from 'date-fns';

const NoPermissions = () => {
  return (
    <Alert severity='error' style={{ fontSize: '14px', padding: '20px', fontWeight: 'bold', border: '1px solid grey' }}>
      You do not have permissions to access this page.
    </Alert>
  );
};

const BetaTag = ({ color, backgroundColor }) => {
  return (
    <span
      className='beta-tag'
      style={{
        color: color,
        backgroundColor: backgroundColor,
      }}>
      BETA
    </span>
  );
};

const CustomOption = (pageName) => (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div id={`${pageName}-option-${data.label}`}>{data.label}</div>
    </components.Option>
  );
};

// Helper function to calculate reporting year dates
const getReportingYearDates = (selectedYear, orgDetails) => {
  const isCalendarYearOrg = orgDetails?.reportingYearEndDay == 31 && orgDetails?.reportingYearEndMonth == 12;
  if (!orgDetails?.reportingYearEndDay || !orgDetails?.reportingYearEndMonth || isCalendarYearOrg) {
    // Fallback to calendar year if reporting year end is not set
    const fallbackFromDate = new Date(selectedYear, 0, 1);
    const fallbackToDate = new Date(selectedYear, 11, 31);
    return {
      fromDate: fallbackFromDate,
      toDate: fallbackToDate,
    };
  }

  const reportingYearEndMonth = orgDetails?.reportingMonth || orgDetails?.reportingYearEndMonth;
  const reportingYearEndDay = orgDetails?.reportingDay || orgDetails?.reportingYearEndDay;

  const toDate = new Date(selectedYear, reportingYearEndMonth - 1, reportingYearEndDay);
  const fromDate = addDays(new Date(selectedYear - 1, reportingYearEndMonth - 1, reportingYearEndDay), 1);

  return { fromDate, toDate };
};

// Helper function to calculate multi-year chart dates (8 years prior to current year)
const getMultiYearChartDates = (currentYear, orgDetails) => {
  if (!orgDetails?.reportingYearEndDay || !orgDetails?.reportingYearEndMonth) {
    // Fallback to calendar year if reporting year end is not set
    const fallbackStartDate = new Date(currentYear - 8, 0, 1);
    const fallbackEndDate = new Date(currentYear, 11, 31);
    return {
      startDate: fallbackStartDate,
      endDate: fallbackEndDate,
    };
  }

  const reportingYearEndMonth = orgDetails?.reportingMonth || orgDetails?.reportingYearEndMonth;
  const reportingYearEndDay = orgDetails?.reportingDay || orgDetails?.reportingYearEndDay;

  const currentDate = new Date();
  const currentYearReportingEnd = new Date(currentYear, reportingYearEndMonth - 1, reportingYearEndDay);
  const isCalendarYearOrg = orgDetails?.reportingYearEndDay == 31 && orgDetails?.reportingYearEndMonth == 12;

  // For multi-year charts, determine the effective year based on organization type
  let effectiveYear = currentYear;
  if (currentDate > currentYearReportingEnd && !isCalendarYearOrg) {
    effectiveYear = currentYear + 1;
  }

  // Calculate the end date (effective year's reporting year end)
  const endDate = new Date(effectiveYear, reportingYearEndMonth - 1, reportingYearEndDay);

  // Calculate the start date (8 years prior to current year's reporting year start)
  const startDate = addDays(addYears(endDate, -8), 1);

  return { startDate, endDate };
};

export { NoPermissions, BetaTag, CustomOption, getReportingYearDates, getMultiYearChartDates };
